import localforage from 'localforage'
import store from '@/store'
import User from '@/services/user'

const switchCurrent = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    User.switchCurrent(payload).then((response) => {
      localforage.setItem('new_current_user', response.data).then(() => {
        store.dispatch('setNewCurrentUser', response.data, { root: true })
      })
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const resetSwitch = async () => {
  return new Promise((resolve, reject) => {
    User.resetSwitch().then((response) => {
      localforage.removeItem('new_current_user').then(() => {
        store.dispatch('removeNewCurrent', { root: true })
      })
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}
const getNewCurrent = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    localforage.getItem('new_current_user').then((response) => {
      store.dispatch('setNewCurrentUser', response, { root: true })
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  switchCurrent,
  resetSwitch,
  getNewCurrent
}



// WEBPACK FOOTER //
// ./src/features/switch_users/store/actions.js